import { endpoint } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/calculatorModals';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'day-one';

/**
 * Care Modal Endpoints:
 *     - Dependency on Income Calculation Modal Endpoint.
 *     - Dependency on Services Calculation Modal Endpoint.
 */
export default {
    /**
     * Table28 Multiplier Endpoint
     * 
     * @return {Promise}
     */
    table28Multiplier: data => endpoint(`${PARENT}/${RESOURCE}`, 'table-28-multiplier', data),
    /**
     * Table E Discount Endpoint
     * 
     * @return {Promise}
     */
    tableEDiscount: data => endpoint(`${PARENT}/${RESOURCE}`, 'table-e-discount', data),
    /**
     * Table F Discount Endpoint
     * 
     * @return {Promise}
     */
    tableFDiscount: data => endpoint(`${PARENT}/${RESOURCE}`, 'table-f-discount', data),
    /**
     * General Damages Endpoint
     * 
     * @return {Promise}
     */
    generalDamages: data => endpoint(`${PARENT}/${RESOURCE}`, 'general-damages', data),
    /**
     * Bereavement Award Endpoint
     * 
     * @return {Promise}
     */
    bereavementAward: data => endpoint(`${PARENT}/${RESOURCE}`, 'bereavement-award', data),
    /**
     * Funeral Expenses Endpoint
     * 
     * @return {Promise}
     */
    funeralExpenses: data => endpoint(`${PARENT}/${RESOURCE}`, 'funeral-expenses', data),
    /**
     * Past Loss Of Earnings Endpoint
     * 
     * @return {Promise}
     */
    pastLossOfEarnings: data => endpoint(`${PARENT}/${RESOURCE}`, 'past-loss-of-earnings', data),
    /**
     * Past Cost Of Services Endpoint
     * 
     * @return {Promise}
     */
    pastCostOfServices: data => endpoint(`${PARENT}/${RESOURCE}`, 'past-cost-of-services', data),
    /**
     * Future Cost Of Services Endpoint
     *
     * @return {Promise}
     */
    futureCostOfServices: data => endpoint(`${PARENT}/${RESOURCE}`, 'future-cost-of-services', data),
    /**
     * Miscellaneous Calc Endpoint
     * 
     * @return {Promise}
     */
    miscellaneousCalc: data => endpoint(`${PARENT}/${RESOURCE}`, 'miscellaneous-calc', data),
    /**
     * Cost Of Care Endpoint
     * 
     * @return {Promise}
     */
    costOfCare: data => endpoint(`${PARENT}/${RESOURCE}`, 'cost-of-care', data),
    /**
     * Dependency on Income Modal Endpoint.
     *
     * @return {Promise}
     */
    dependencyOnIncome: data => endpoint(`${PARENT}/${RESOURCE}`, 'dependency-on-income', data),
    /**
     * Dependency on Services Modal Endpoint.
     *
     * @return {Promise}
     */
    dependencyOnServices: data => endpoint(`${PARENT}/${RESOURCE}`, 'dependency-on-services', data),
};



// WEBPACK FOOTER //
// ./src/services/api/calculatorModals/dayOne.js